/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiBatchCreateCompanyResponseFailureFromJSON, StreemApiBatchCreateCompanyResponseFailureToJSON, StreemApiCreateCompanyResponseFromJSON, StreemApiCreateCompanyResponseToJSON, } from './';
export function StreemApiBatchCreateCompanyResponseFromJSON(json) {
    return StreemApiBatchCreateCompanyResponseFromJSONTyped(json, false);
}
export function StreemApiBatchCreateCompanyResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'created': !exists(json, 'created') ? undefined : (json['created'].map(StreemApiCreateCompanyResponseFromJSON)),
        'failed': !exists(json, 'failed') ? undefined : (json['failed'].map(StreemApiBatchCreateCompanyResponseFailureFromJSON)),
    };
}
export function StreemApiBatchCreateCompanyResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'created': value.created === undefined ? undefined : (value.created.map(StreemApiCreateCompanyResponseToJSON)),
        'failed': value.failed === undefined ? undefined : (value.failed.map(StreemApiBatchCreateCompanyResponseFailureToJSON)),
    };
}
//# sourceMappingURL=StreemApiBatchCreateCompanyResponse.js.map